<template>
  <li :class="['task-item', { completed: stepSeconds > 0 }]">
    <div class="text">{{ text }}</div>
    <div v-if="showMetrics" class="metrics-container">
      <span class="metric-pill va">
        <span class="metric-label">VA</span>
        <span class="metric-value">{{ formatTime(displayMetrics.vaTime) }}</span>
      </span>
      <span class="metric-pill nva">
        <span class="metric-label">NVA</span>
        <span class="metric-value">{{ formatTime(displayMetrics.nvaTime) }}</span>
      </span>
      <span class="metric-pill total">
        <span class="metric-label">Total</span>
        <span class="metric-value">{{ formatTime(displayMetrics.totalTime) }}</span>
      </span>
    </div>
    <div v-else class="text">{{ stepTime }}</div>
  </li>
</template>

<script>
import { computed } from 'vue';

export default {
  name: 'TaskItem',
  props: {
    text: { type: String, required: true },
    substepIndex: { type: Number, required: true },
    stepsTime: { type: Object, default: () => ({}) },
    substepMetrics: { type: Object, default: () => ({}) },
  },
  setup(props) {
    const stepSeconds = computed(() =>
      Number(props.stepsTime?.[props.substepIndex] ?? 0)
    );
    const stepTime = computed(() => `${stepSeconds.value.toFixed(2)} s`);

    const metrics = computed(() => props.substepMetrics?.[props.substepIndex]);

    const displayMetrics = computed(() => {
      if (metrics.value) return metrics.value;
      const time = stepSeconds.value;
      return { vaTime: time, nvaTime: 0, totalTime: time };
    });

    const showMetrics = computed(() => {
      const hostname = window.location.hostname;
      return hostname === 'bmw-germany.retrocausal.tech' || hostname === 'localhost';
    });

    const formatTime = (time) => {
      return `${Number(time || 0).toFixed(2)} s`;
    };

    return { stepSeconds, stepTime, displayMetrics, showMetrics, formatTime };
  },
};
</script>

<style scoped>
.task-item {
  display: flex;
  gap: 0.5em;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #fafafa;
  padding: 8px 10px;
}

.completed {
  background: #f0fdf4;
}

.text {
  font-size: var(--fs-sm);
  line-height: 1.35;
  color: #1f2937;
  flex: 1 1 auto;
  min-width: 120px;
}

.metrics-container {
  display: flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;
  flex-shrink: 1;
  margin-left: auto;
}

.metric-pill {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: var(--fs-xs);
  padding: 2px 7px;
  border-radius: 6px;
  line-height: 1.4;
}

.metric-pill.va {
  background: #f0fdf4;
  color: #15803d;
}

.metric-pill.nva {
  background: #fefce8;
  color: #a16207;
}

.metric-pill.total {
  background: #eff6ff;
  color: #1d4ed8;
}

.metric-label {
  font-weight: 600;
  font-size: var(--fs-xs);
  opacity: 0.75;
}

.metric-value {
  font-weight: 500;
}
</style>
